const ConstituencyMapModule = () => import('./ConstituencyMapModule.vue')
import ConstituencyMap from './views/ConstituencyMap.vue'

export const constituencyMapModuleRoute = {
  name: 'constituencyMap',
  path: '/constituency-map',
  component: ConstituencyMapModule,
  children: [
    {
      path: 'constituency',
      name: 'map.constituency',
      component: ConstituencyMap
    }
  ]
}
